export default {"src":"/uk/_next/static/media/spot-search.38a31f85.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};